// @ts-nocheck THIS IS A GENERATED FILE, DO NOT EDIT
import * as PrivateSchemaTypes from '../../graphql/private/PrivateSchemaTypes';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
import * as ApolloReactHooks from '@apolloHooksWithThrowingQuery';
const defaultOptions =  {}
export type TagsForPathwaysQueryVariables = PrivateSchemaTypes.Exact<{ [key: string]: never; }>;


export type TagsForPathwaysQuery = (
  { __typename?: 'Query' }
  & { tags?: PrivateSchemaTypes.Maybe<Array<(
    { __typename?: 'TagModel' }
    & Pick<PrivateSchemaTypes.TagModel, 'id' | 'name'>
  )>> }
);

export type PathwayStudentViewQueryVariables = PrivateSchemaTypes.Exact<{
  tagId?: PrivateSchemaTypes.Maybe<PrivateSchemaTypes.Scalars['PositiveInt']>;
  page?: PrivateSchemaTypes.Maybe<PrivateSchemaTypes.Scalars['NonNegativeInt']>;
  limit?: PrivateSchemaTypes.Maybe<PrivateSchemaTypes.Scalars['PositiveInt']>;
  enrolmentsFilter: PrivateSchemaTypes.PathwaysListEnrolmentsFilter;
}>;


export type PathwayStudentViewQuery = (
  { __typename?: 'Query' }
  & { pathways: (
    { __typename?: 'PathwaysPaginated' }
    & Pick<PrivateSchemaTypes.PathwaysPaginated, 'count'>
    & { items: Array<(
      { __typename?: 'PathwayModelAsStudent' }
      & PathwayWithCurrentEnrolmentFragment
    )> }
  ) }
);

export type PathwayWithCurrentEnrolmentFragment = (
  { __typename?: 'PathwayModelAsStudent' }
  & Pick<PrivateSchemaTypes.PathwayModelAsStudent, 'id' | 'title' | 'progress' | 'currentTopicVersionsCount'>
  & { coverImage?: PrivateSchemaTypes.Maybe<(
    { __typename?: 'DocumentModel' }
    & Pick<PrivateSchemaTypes.DocumentModel, 'id' | 'cdnUrl'>
  )>, coverImageVariants: Array<(
    { __typename?: 'ImageVariantModel' }
    & Pick<PrivateSchemaTypes.ImageVariantModel, 'cdnUrl' | 'size_key'>
  )>, tags: Array<(
    { __typename?: 'TagModel' }
    & Pick<PrivateSchemaTypes.TagModel, 'id' | 'name'>
  )>, currentEnrolment?: PrivateSchemaTypes.Maybe<(
    { __typename?: 'PathwayEnrolmentModelAsStudent' }
    & Pick<PrivateSchemaTypes.PathwayEnrolmentModelAsStudent, 'id' | 'pathway_id' | 'progress' | 'target_date' | 'status' | 'completed_at' | 'completed_status'>
  )> }
);

export const PathwayWithCurrentEnrolmentFragmentDoc = gql`
    fragment PathwayWithCurrentEnrolment on PathwayModelAsStudent {
  id
  title
  progress
  currentTopicVersionsCount
  coverImage {
    id
    cdnUrl
  }
  coverImageVariants {
    cdnUrl
    size_key
  }
  tags {
    id
    name
  }
  currentEnrolment {
    id
    pathway_id
    progress
    target_date
    status
    completed_at
    completed_status
  }
}
    `;
export const TagsForPathwaysDocument = gql`
    query tagsForPathways {
  tags(having: PATHWAYS) {
    id
    name
  }
}
    `;

/**
 * __useTagsForPathwaysQuery__
 *
 * To run a query within a React component, call `useTagsForPathwaysQuery` and pass it any options that fit your needs.
 * When your component renders, `useTagsForPathwaysQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTagsForPathwaysQuery({
 *   variables: {
 *   },
 * });
 */
export function useTagsForPathwaysQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<TagsForPathwaysQuery, TagsForPathwaysQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<TagsForPathwaysQuery, TagsForPathwaysQueryVariables>(TagsForPathwaysDocument, options);
      }
export function useTagsForPathwaysLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<TagsForPathwaysQuery, TagsForPathwaysQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<TagsForPathwaysQuery, TagsForPathwaysQueryVariables>(TagsForPathwaysDocument, options);
        }
export type TagsForPathwaysQueryHookResult = ReturnType<typeof useTagsForPathwaysQuery>;
export type TagsForPathwaysLazyQueryHookResult = ReturnType<typeof useTagsForPathwaysLazyQuery>;
export type TagsForPathwaysQueryResult = Apollo.QueryResult<TagsForPathwaysQuery, TagsForPathwaysQueryVariables>;
export const PathwayStudentViewDocument = gql`
    query pathwayStudentView($tagId: PositiveInt, $page: NonNegativeInt, $limit: PositiveInt, $enrolmentsFilter: PathwaysListEnrolmentsFilter!) {
  pathways(
    tagId: $tagId
    page: $page
    limit: $limit
    enrolments: $enrolmentsFilter
  ) {
    count
    items {
      ...PathwayWithCurrentEnrolment
    }
  }
}
    ${PathwayWithCurrentEnrolmentFragmentDoc}`;

/**
 * __usePathwayStudentViewQuery__
 *
 * To run a query within a React component, call `usePathwayStudentViewQuery` and pass it any options that fit your needs.
 * When your component renders, `usePathwayStudentViewQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePathwayStudentViewQuery({
 *   variables: {
 *      tagId: // value for 'tagId'
 *      page: // value for 'page'
 *      limit: // value for 'limit'
 *      enrolmentsFilter: // value for 'enrolmentsFilter'
 *   },
 * });
 */
export function usePathwayStudentViewQuery(baseOptions: ApolloReactHooks.QueryHookOptions<PathwayStudentViewQuery, PathwayStudentViewQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<PathwayStudentViewQuery, PathwayStudentViewQueryVariables>(PathwayStudentViewDocument, options);
      }
export function usePathwayStudentViewLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<PathwayStudentViewQuery, PathwayStudentViewQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<PathwayStudentViewQuery, PathwayStudentViewQueryVariables>(PathwayStudentViewDocument, options);
        }
export type PathwayStudentViewQueryHookResult = ReturnType<typeof usePathwayStudentViewQuery>;
export type PathwayStudentViewLazyQueryHookResult = ReturnType<typeof usePathwayStudentViewLazyQuery>;
export type PathwayStudentViewQueryResult = Apollo.QueryResult<PathwayStudentViewQuery, PathwayStudentViewQueryVariables>;